import React from 'react';
const noMore = ['No more rebuilding every class and skills lab from scratch.', 'No more hours searching scattered textbooks, slides and videos.', 'No more explaining procedures, assessments and calculations with words alone.', 'No more students memorizing steps without understanding why.', 'No more skills labs and simulations without clear visual material.', 'No more repeating the same corrections every week.', 'No more assessing competencies without clear criteria.', 'No more losing time you could spend actually teaching.'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-[#0B2545] relative overflow-hidden" data-id="element-125" data-mp="vv9qflc7xnol">
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-126" data-mp="vwkwjrt4z7iv">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-8 leading-tight text-white uppercase" data-id="element-127" data-mp="qw6sslykijqn">
          Next Month You Can Still Be Searching for Nursing Teaching Material...
          <br data-id="element-128" data-mp="zxxznu4ugwm3" />
          <span className="text-[#7FD6D1]" data-id="element-129" data-mp="zua4yrnny45s">
            Or You Can Have a Complete Visual Training System Ready for Your Next Session.
          </span>
        </h2>
        <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white p-8 rounded-2xl border border-[#7FD6D1]/60" data-id="element-130" data-mp="2h4spsh4ofrts">
          {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-131" data-mp="2r1xhsxl7ehii">
              <span className="text-[#0A7D79] mt-0.5" aria-hidden="true" data-id="element-132" data-mp="2r38keu2wxj81">
                ▸
              </span>
              <span className="text-slate-700" data-id="element-133" data-mp="2v1fzzlln4ehn">{item}</span>
            </div>)}
        </div>
        <p className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-134" data-mp="300iyen747mgn">
          NURSING INSTRUCTOR ATLAS doesn&apos;t replace your clinical experience, an accredited nursing curriculum or
          your institution&apos;s clinical policies.
        </p>
        <p className="text-xl text-white/80 mb-6" data-id="element-135" data-mp="3esjddpe0u9bm">
          It supports your teaching with a structured visual system designed to give you more:
        </p>
        <p className="text-lg md:text-2xl font-extrabold tracking-widest text-[#7FD6D1]" data-id="element-136" data-mp="1jocxmctvixw0">
          CLARITY · STRUCTURE · CONSISTENCY · CONFIDENCE
        </p>
      </div>
    </section>;
}